import React, { useContext, useState, useRef, useCallback } from 'react';
import { ContextoFinanceiro } from '../../../../services/financeiro';
import BtnSelecionarParcela from '../BtnSelecionarParcela';
import Format from '../../../../Utils/formatCurrent';
import FormatDate from '../../../../Utils/formatDate';
import { ReactComponent as Financeiro } from '../../../../assets/novosicones/menu/Financeiro.svg';
import { ReactComponent as ParcelaPausada } from '../../../../assets/novosicones/Financeiro/parcelaPausedIcon.svg';

import verificaSeParcelaAtrasada from '../../../../Utils/checkIfBillIsLate';

import ShowBoleto from '../../ShowBoleto';

import LoadPdfBoleto from '../loadPdfBoleto';

import { ReactComponent as RenegociacaoIcon } from '../../../../assets/novosicones/Financeiro/handshake_black_24dp.svg';

import { ReactComponent as HelpIcon } from '../../../../assets/novosicones/help_outline.svg';

import {
  CardContainer,
  Container,
  MsgParcelaBloqueada,
  MsgErroBoleto,
} from './styles';

import { ReactComponent as Erro } from '../../../../assets/icones/error.svg';
import BotaoPix from '../ResumoBoletosPendentes/BotaoPix';
import TooltipStandard from '../../../TooltipStandard';
import { TEXT_PIX_TOOLTIP } from '../ResumoBoletosPendentes/functionsCardBoletos';

const CardParcela = ({
  parcela,
  setParcelasSelecionadas,
  parcelasSelecionadas,
  tema,
  index,
  codOcorrencia,
  parcelasAPagar,
  simulacaoRenegociacao,
  desabilitarBtnSelecionarParcela,
  // simulador,
}) => {
  const { getVisualizarBoleto, parcelaBloqueadaClicada } =
    useContext(ContextoFinanceiro);

  const [loadingPdfBoleto, setLoadingPdfBoleto] = useState(false);

  const [showPdfBoleto, setShowPdfBoleto] = useState(false);

  const [base64PdfBoleto, setBase64PdfBoleto] = useState('');

  const [error, setError] = useState(false);

  const [parcelaBloqueada, setParcelaBloqueada] = useState('');

  const getPDFVisualizarBoleto = useCallback(async (Cod_banco, Seu_numero) => {
    setLoadingPdfBoleto(true);
    let result = '';
    try {
      result = await getVisualizarBoleto(Cod_banco, Seu_numero);
      setLoadingPdfBoleto(false);
      setBase64PdfBoleto(result.data);
      setShowPdfBoleto(true);
      executeScroll();
    } catch (error) {
      setError(true);
    } finally {
      setLoadingPdfBoleto(false);
    }
  }, []);

  const renegociacao = parcela?.contratoRenegociado;

  const pdfBoleto = useRef(null);

  const executeScroll = () => pdfBoleto.current.scrollIntoView();

  if (error)
    setTimeout(() => {
      setError(false);
    }, 5000);

  const formatParcela = (parc) => (parc < 10 ? '0' + parc : parc);
  const handleValor = () => {
    if (simulacaoRenegociacao) {
      return Format(parcela.valorRenegociacao);
    }

    return Format(parcela.valorReajustado);
  };

  const handleValorAtualizado = () =>
    simulacaoRenegociacao
      ? Format(parcela.valorRenegociacao)
      : Format(parcela.valorReajustado);

  const handleIcon = () => {
    if (simulacaoRenegociacao || renegociacao) {
      return <RenegociacaoIcon />;
    } else if (!renegociacao && !parcela.exibirGeraBoleto) {
      return <ParcelaPausada style={{ fill: '#fff' }} />;
    } else {
      return <Financeiro style={{ fill: '#fff' }} />;
    }
  };
  return (
    <>
      {showPdfBoleto && (
        <ShowBoleto
          showPdfBoleto={showPdfBoleto}
          setShowPdfBoleto={setShowPdfBoleto}
          base64PdfBoleto={base64PdfBoleto}
          pdfBoleto={pdfBoleto}
          tema={tema}
          vencimentoBoleto={FormatDate(parcela?.dtVencBoleto)}
        />
      )}

      <Container>
        {!simulacaoRenegociacao && !desabilitarBtnSelecionarParcela && (
          <div className='container-btn-selecionar-parcela'>
            <BtnSelecionarParcela
              index={index}
              setParcelasSelecionadas={setParcelasSelecionadas}
              parcelasSelecionadas={parcelasSelecionadas}
              parcela={parcela}
              tema={tema}
              temBoleto={parcela.temBoleto}
              exibirGeraBoleto={parcela.exibirGeraBoleto}
              codOcorrencia={codOcorrencia}
              parcelasAPagar={parcelasAPagar}
              setBloqueada={setParcelaBloqueada}
              parcelaBloqueada={parcelaBloqueada}
              temCartao={parcela.temCartao}
              temPix={parcela.temPix}
            />
          </div>
        )}

        <CardContainer
          tema={tema}
          vencida={verificaSeParcelaAtrasada(parcela.dataVencimento)}
          temCartao={parcela.temCartao}
          temPix={parcela.temPix}
        >
          <div className='first-section'>
            {error && <Erro className='icone-erro-boleto' />}
            {!error && (
              <div className='icon-container'>
                {!error && (
                  <LoadPdfBoleto
                    parcela={parcela}
                    loadingPdfBoleto={loadingPdfBoleto}
                    getPDFVisualizarBoleto={getPDFVisualizarBoleto}
                    tema={tema}
                  />
                )}
                {!parcela.temBoleto && <span>{handleIcon()}</span>}
              </div>
            )}
            <div className='container-fields'>
              <div className='field'>
                <span className='field-title'>Tipo/descrição:</span>
                <span className='description'>{parcela?.descricaoParcela}</span>
              </div>
              <div className='field'>
                <span className='field-title'>Valor:</span>
                <span className='color value'>{handleValor()}</span>
              </div>
            </div>
          </div>
          <div className='divider'></div>
          <div className='second-section'>
            <div className='field'>
              <span className='field-title'>Valor atualizado: </span>
              <span className='field-value'>{handleValorAtualizado()}</span>
            </div>
          </div>
          <div className='divider'></div>
          <div className='third-section'>
            <div className='field'>
              <span className='field-title'>
                Parcela: {formatParcela(parcela?.numeroParcela)}/
                {formatParcela(parcela?.totParc)}
              </span>
            </div>
            <div>
              {!parcela?.temCartao && !parcela?.temPix && (
                <span className='field-title color vencimento'>
                  Vencimento: {FormatDate(parcela?.dataVencimento)}
                </span>
              )}
              {parcela?.temCartao && (
                <span className='field-title processing-message'>
                  Processando seu pagamento por cartão
                </span>
              )}
              {parcela?.temPix && (
                <>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span className='field-title processing-message'>
                      Processando seu pagamento por pix
                    </span>
                    <TooltipStandard title={TEXT_PIX_TOOLTIP}>
                      <span style={{ marginLeft: 8 }}>
                        <HelpIcon />
                      </span>
                    </TooltipStandard>
                  </div>
                  <BotaoPix
                    isCardParcelas
                    processandoPix
                    parcelas={[{ parcela }]}
                  />
                </>
              )}
            </div>
          </div>
        </CardContainer>
      </Container>

      {error && (
        <MsgErroBoleto>
          Erro ao visualizar o boleto, tente novamente mais tarde.
        </MsgErroBoleto>
      )}

      {!simulacaoRenegociacao &&
        parcelaBloqueadaClicada === parcela.idReceber &&
        !parcela.exibirGeraBoleto && (
          <MsgParcelaBloqueada>
            *Parcela indisponível para geração do boleto por estar pendente a
            baixa ou repasse no sistema.
          </MsgParcelaBloqueada>
        )}
    </>
  );
};

export default CardParcela;
